export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/resources/images/favicon/favicon.ico"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/resources/images/favicon/apple-icon-180x180.png"},{"rel":"icon","sizes":"36x36","type":"image/png","href":"/resources/images/favicon/android-icon-36x36.png"},{"rel":"icon","sizes":"48x48","type":"image/png","href":"/resources/images/favicon/android-icon-48x48.png"},{"rel":"icon","sizes":"96x96","type":"image/png","href":"/resources/images/favicon/android-icon-96x96.png"},{"rel":"icon","sizes":"144x144","type":"image/png","href":"/resources/images/favicon/android-icon-144x144.png"},{"rel":"icon","sizes":"192x192","type":"image/png","href":"/resources/images/favicon/android-icon-192x192.png"}],"style":[],"script":[{"src":"/resources/js/gtm.js","rel":"preconnect"},{"src":"https://imgsct.cookiebot.com","rel":"preconnect"},{"src":"https://consent.cookiebot.com","rel":"preconnect"},{"src":"https://www.googletagmanager.com","rel":"preconnect"}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false